import * as React from 'react';
import ReportTabs from "../reports/tab";

export const TravelCreditReports = props => {
    return (<ReportTabs type={'travel_credit_report'}/>)
};